import { PlannerGlobals } from 'src/components/Planner/planner/planner-globals';

export function isLightingActive(): boolean {
  return !!(PlannerGlobals.LIGHTING_CALC && PlannerGlobals.LIGHTING_CALC.inLightCalcMode);
}

export function startLighting(): Promise<void> {
  if (PlannerGlobals.LIGHTING_CALC) {
    return PlannerGlobals.LIGHTING_CALC.startLightCalcMode();
  }
  return Promise.resolve();
}

export function stopLighting(): void {
  if (PlannerGlobals.LIGHTING_CALC) {
    PlannerGlobals.LIGHTING_CALC.stopLightCalcMode();
  }
}
